import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { ASSETS, FINAL_CTA } from "../../data/content";
import Reveal from "./Reveal";

export default function FinalCTA() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], ["-15%", "15%"]);

  return (
    <section
      id="enquire"
      ref={ref}
      data-testid="final-cta-section"
      className="relative min-h-screen bg-[#050B14] overflow-hidden flex items-center"
    >
      {/* Background */}
      <motion.img
        style={{ y }}
        src={ASSETS.yacht.sunsetWide}
        alt=""
        aria-hidden="true"
        loading="lazy"
        className="absolute inset-0 w-full h-[130%] object-cover opacity-40"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-[#050B14] via-[#050B14]/70 to-[#050B14]/90" />
      <div className="absolute top-0 left-0 right-0 h-px bg-white/10" />

      <div className="relative z-10 max-w-[1600px] mx-auto px-6 md:px-12 py-32 md:py-40 w-full">
        <div className="grid grid-cols-12 gap-6">
          <div className="col-span-12 lg:col-span-10 lg:col-start-2">
            <Reveal>
              <div className="flex items-center gap-4 mb-10 justify-center">
                <div className="h-px w-12 bg-[#E5D3B3]" />
                <span className="overline">{FINAL_CTA.overline}</span>
                <div className="h-px w-12 bg-[#E5D3B3]" />
              </div>
            </Reveal>

            <Reveal delay={0.1}>
              <h2
                data-testid="final-headline"
                className="font-serif-display text-white text-center text-[clamp(2.5rem,6vw,6rem)] leading-[1.02] font-light tracking-[-0.02em] whitespace-pre-line"
              >
                {FINAL_CTA.title}
              </h2>
            </Reveal>

            <Reveal delay={0.3}>
              <div className="mt-16 flex flex-col sm:flex-row items-center justify-center gap-5">
                <a
                  href={`mailto:${FINAL_CTA.email}?subject=Enquiry%20-%20MARIE-JOSEPH%20Sunreef%2080%20Eco`}
                  data-testid="final-cta-enquire"
                  className="btn-primary"
                >
                  {FINAL_CTA.primary}
                  <span aria-hidden="true">→</span>
                </a>
                <a
                  href={FINAL_CTA.dossierUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="final-cta-dossier"
                  className="btn-ghost"
                >
                  {FINAL_CTA.secondary}
                </a>
              </div>
            </Reveal>

            <Reveal delay={0.45}>
              <div className="mt-20 text-center">
                <div className="overline text-white/40 mb-3">Direct</div>
                <a
                  href={`mailto:${FINAL_CTA.email}`}
                  data-testid="final-cta-email"
                  className="link-underline font-serif-display italic text-white/80 text-lg md:text-xl"
                >
                  {FINAL_CTA.email}
                </a>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
